import React, {useState, useEffect, useContext} from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { FaStarOfLife } from 'react-icons/fa6';
import { AxiosResponse } from 'axios';
import { instance } from '../../../api/axiosInstance';
import {UserResponseDTO} from "../../profileSetting/UserDTO";
import Cookies from 'js-cookie';
import {toast} from "react-toastify";
import {UserContext} from "../../../components/UserContext";

export default function LoginPage() {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [id, setId] = useState(''); // 아이디 상태 추가
  const [password, setPassword] = useState(''); // 비밀번호 상태 추가
  const [saveId, setSaveId] = useState(false); // ID 저장 상태 추가
  const [error, setError] = useState<string | null>(null); // 에러 메시지 상태 추가
  const navigate = useNavigate(); // 페이지 이동을 위한 useNavigate 훅 사용

  useEffect(() => {
    // ID 저장이 활성화되어 있으면 저장된 ID를 불러와 설정
    const idSaved = localStorage.getItem('saveId') === 'true';
    if (idSaved) {
      const savedId = localStorage.getItem('savedId');
      if (savedId) setId(savedId);
      setSaveId(true);
    }

  }, [navigate]); // `navigate`를 의존성 배열에 추가

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  const { setUser } = useContext(UserContext); // setUser 함수 사용
  // 로그인 처리 함수
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault(); // 폼 제출 기본 동작 방지
    setError(null); // 이전 에러 메시지 초기화

    try {
      const response: AxiosResponse<UserResponseDTO> = await instance.post('/api/users/login', {
        username: id,
        password: password,
      });

      const data = response.data;

      // **1. access_token 쿠키에 저장**
      Cookies.set('access_token', data.token, {
        expires: 7, // 7일 동안 유효
        secure: true, // HTTPS에서만 전송
        sameSite: 'Strict', // CSRF 방지
        path: '/', // 전체 사이트에서 쿠키 접근 가능
      });

      // **2. ID 저장 설정 처리**
      if (saveId) {
        localStorage.setItem('saveId', 'true');
        localStorage.setItem('savedId', id);
      } else {
        localStorage.removeItem('saveId');
        localStorage.removeItem('savedId');
      }

      // **3. 사용자 정보 로컬 스토리지에 저장**
      const userData = {
        id: data.id,
        token:data.token,
        username: data.username,
        fullName: data.fullName,
        email: data.email,
        phone: data.phone,
        referralCode: data.referralCode,
        roles: data.roles,
        createdAt: data.createdAt,
        nickname: data.nickname,
        isSeller: data.isSeller,
        profileImageUrl: data.profileImageUrl,
        snsPublic: data.snsPublic,
        _seller: data.isSeller,
        uuid: data.uuid
      };

      localStorage.setItem('user', JSON.stringify(userData));

      // **4. UserProvider의 setUser 호출하여 전역 상태 업데이트**
      setUser(userData);

      // **5. 로그인 성공 후 홈으로 네비게이션**
      navigate('/');
    } catch (err: any) {
      // 로그인 실패 시 로컬 스토리지에서 auth 토큰 제거
      localStorage.removeItem('auth');

      console.error('로그인 에러:', err);

      let errorMessage = '로그인에 실패했습니다.';

      if (err.response) {
        // 서버 응답이 있는 경우
        const data = err.response.data;
        if (data) {
          if (typeof data === 'string') {
            errorMessage = data;
          } else if (typeof data.message === 'string') {
            errorMessage = data.message;
          } else {
            errorMessage = JSON.stringify(data);
          }
        }
      } else if (err.request) {
        // 요청이 만들어졌으나 응답을 받지 못한 경우
        errorMessage = '서버에 응답하지 않습니다. 나중에 다시 시도해주세요.';
      } else {
        // 요청을 설정하는 중에 오류가 발생한 경우
        errorMessage = '로그인 중 오류가 발생했습니다.';
      }

      // 에러 메시지를 상태로 설정
      setError(errorMessage);

      // 사용자에게 토스트 알림으로 에러 메시지 표시
      toast.error(errorMessage);
    }
  };
  return (
      <section className="flex items-center justify-center min-h-screen bg-white">
        <div className="w-full max-w-md mobile:px-4">
          <div className="flex justify-center w-full">
            <NavLink to="/">
              <img
                  src={`${process.env.PUBLIC_URL}/logo/logo.png`}
                  alt="Creator Store"
                  className="h-auto object-cover"
              />
            </NavLink>
          </div>
          <h1 className="font-medium text-[#747474] text-base mobile:text-sm text-center mb-10">
            로그인하고 다양한 크리에이터 콘텐츠를 즐겨보세요!
          </h1>
          {error && (
              <div
                  className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"
                  role="alert"
              >
                <strong className="font-bold">오류!</strong>
                <span className="block sm:inline ml-2">
              {typeof error === 'string' ? error : JSON.stringify(error)}
            </span>
              </div>
          )}
          <form onSubmit={handleLogin} className="mt-6 ">
            {/* 아이디 */}
            <div className="mb-9">
              <label htmlFor="id" className="text-[#111] font-medium mb-2 text-base mobile:text-sm  flex gap-1">
                아이디
                <span>
                <FaStarOfLife className="text-[#ef4444] text-[8px]" />
              </span>
              </label>
              <input
                  type="text"
                  id="id"
                  value={id} // 아이디 입력 상태 연결
                  onChange={(e) => setId(e.target.value)} // 아이디 입력 상태 업데이트
                  required
                  className="w-full px-4 py-4 border-b placeholder:text-[#c8c8c8c8] text-MainTextColor focus:outline-none"
                  placeholder="아이디 입력"
              />
            </div>
            {/* 비밀번호 */}
            <div className="mb-4 relative">
              <label htmlFor="password" className="text-[#111] font-medium mb-2 text-base mobile:text-sm  flex gap-1">
                비밀번호
                <span>
                <FaStarOfLife className="text-[#ef4444] text-[8px]" />
              </span>
              </label>
              <input
                  type={passwordVisible ? 'text' : 'password'}
                  id="password"
                  value={password} // 비밀번호 입력 상태 연결
                  onChange={(e) => setPassword(e.target.value)} // 비밀번호 입력 상태 업데이트
                  required
                  className="w-full px-4 py-4 border-b placeholder:text-[#c8c8c8c8] text-MainTextColor focus:outline-none"
                  placeholder="비밀번호 입력"
              />
              <div
                  className="absolute top-[45px] text-[#969696c8] right-4 flex items-center cursor-pointer"
                  onClick={togglePasswordVisibility}
              >
                {passwordVisible ? <AiOutlineEye size={24} /> : <AiOutlineEyeInvisible size={24} />}
              </div>
            </div>
            {/* ID 저장하기 */}
            <div className="flex items-center justify-between mt-8 mb-6">
              <div className="flex items-center">
                <input
                    type="checkbox"
                    id="saveId"
                    checked={saveId}
                    onChange={(e) => setSaveId(e.target.checked)}
                    className="custom-checkbox mr-2"
                />
                <label htmlFor="saveId" className="text-[#111] mobile:text-xs  cursor-pointer text-sm">
                  ID 저장하기
                </label>
              </div>

              {/* 회원가입 및 비밀번호 찾기 링크 */}
              <div className="flex space-x-4">
                <NavLink to="/signup" className="text-[#787893] text-xs font-light hover:underline">
                  회원가입
                </NavLink>
                <NavLink to="/find" className="text-[#787893] text-xs font-light hover:underline">
                  아이디/비밀번호 찾기
                </NavLink>
              </div>
            </div>
            {/* 로그인 버튼 */}
            <button
                type="submit"
                className="bg-[#04c2c5] text-white w-full mt-[40px] tracking-wide shadow-sm font-bold text-base py-4 rounded-full hover:bg-opacity-70 transition duration-300"
            >
              로그인
            </button>
          </form>
        </div>
      </section>
  );
}
